import React, { memo } from 'react';
import { IconButton, Stack, Tooltip } from '@mui/material';
import { ZoomIn, ZoomOut, RestartAlt } from '@mui/icons-material';
import { MIN_ZOOM, MAX_ZOOM } from './audioUtils';

const ZoomControls = memo(({ 
    isLoading, 
    zoom, 
    onZoomIn, 
    onZoomOut, 
    onReset, 
    colors 
}) => {
    return (
        <Stack direction="row" spacing={0.5}>
            <Tooltip title="Zoom Out">
                <span>
                    <IconButton 
                        onClick={onZoomOut} 
                        disabled={isLoading || zoom <= MIN_ZOOM}
                        size="small"
                        sx={{
                            color: colors.text,
                            '&:hover': {
                                bgcolor: colors.hoverBg
                            }
                        }}
                    >
                        <ZoomOut fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>
            <Tooltip title="Zoom In">
                <span>
                    <IconButton 
                        onClick={onZoomIn} 
                        disabled={isLoading || zoom >= MAX_ZOOM}
                        size="small"
                        sx={{
                            color: colors.text,
                            '&:hover': {
                                bgcolor: colors.hoverBg
                            }
                        }}
                    >
                        <ZoomIn fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>
            <Tooltip title="Reset Selection">
                <span>
                    <IconButton 
                        onClick={onReset} 
                        disabled={isLoading}
                        size="small"
                        sx={{
                            color: colors.text,
                            '&:hover': {
                                bgcolor: colors.hoverBg
                            }
                        }}
                    >
                        <RestartAlt fontSize="small" />
                    </IconButton>
                </span>
            </Tooltip>
        </Stack>
    );
});

ZoomControls.displayName = 'ZoomControls';

export default ZoomControls;

